import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-improvement',
  templateUrl: './customer-improvement.component.html',
  styleUrls: ['./customer-improvement.component.scss']
})
export class CustomerImprovementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
